import React from "react";
import axiosUpload from "../../utility/axiosUpload";
import { toast } from "sonner";

const useUploadFiles = () => {
  const [loader, loaderSet] = React.useState(false);
  // const [file_loader, file_loaderSet] = React.useState(false);

  /**
   * Upload single or multiple files/images
   */
  const uploadFile = async (files: File | File[] | null, name?: string) => {
    loaderSet(true);

    try {
      const formData = new FormData();

      if (files) {
        if (Array.isArray(files)) {
          files.forEach((file) => formData.append("files[]", file));
        } else {
          formData.append("files[]", files);
        }
      }

      if (name) {
        formData.append("name", name);
      }

      const config = {
        transformRequest: (formData: FormData) => formData,
      };

      const response = await axiosUpload.post("/v1/upload", formData, config);
      return response.data;
    } catch (error) {
      console.error("Upload failed", error);
      return [];
    } finally {
      loaderSet(false);
    }
  };

  const deleteFiles = async (name: string) => {
    loaderSet(true);
    try {
      const response = await axiosUpload.post("/v1/destroy-upload", { name });
      toast.success("File deleted successfully");
      return response.data;
    } catch (error) {
      console.error("❌ Delete failed", error);
      return false;
    } finally {
      loaderSet(false);
    }
  };

  return { loader, uploadFile, deleteFiles };
};

export default useUploadFiles;
